<div class="mt-3">
  <div class="col-md-6 form-group">
    <select  class="form-control" [(ngModel)]="cdid">
      <option [value]="item.cdid" *ngFor="let item of CondoList">{{item.cdid}} {{item.cd_name}} -
        {{item.bld_name}}</option>
    </select>
  </div>

    <div class="col-md-6 form-group ">
    <span> ชั้นที่ </span>
    <input type="text" class="form-control"  [(ngModel)]="floor"/>
  </div>

 <div class="col-md-6 form-group ">
    <span> ราคา </span>
    <input type="number" class="form-control"  [(ngModel)]="price"/>
  </div>


   <div class="col-md-6 form-group ">
    <button class="btn btn-success" (click)="updatePrice()"> ปรับปรุงราคา</button>
  </div>
</div>